import { render } from "./edit_sale.vue?vue&type=template&id=70c4e122"
import script from "./edit_sale.vue?vue&type=script&lang=js"
export * from "./edit_sale.vue?vue&type=script&lang=js"

import "./edit_sale.vue?vue&type=style&index=0&id=70c4e122&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__